import { render, staticRenderFns } from "./ModalEditPhotoBeforeAfter.vue?vue&type=template&id=71f786fb&scoped=true"
import script from "./ModalEditPhotoBeforeAfter.vue?vue&type=script&lang=js"
export * from "./ModalEditPhotoBeforeAfter.vue?vue&type=script&lang=js"
import style0 from "./ModalEditPhotoBeforeAfter.vue?vue&type=style&index=0&id=71f786fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f786fb",
  null
  
)

export default component.exports